import { logger } from '../services/Logger';

export const asyncHandler = async <T>(promise, errorMsg?: string): Promise<[T, Error | null]> => {
	try {
		const data = await promise;
		return [data, null];
	} catch (error) {
		logger.error(errorMsg, error);
		return [null, error];
	}
};
